// extracted by mini-css-extract-plugin
module.exports = {"myListButton":"rU","bigIcon":"rV","iconOnHoverStyle":"rW","iconOnHoverRentalStyle":"rX","inOnboardingRecommendation":"rY"};